var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuotes = function SvgQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 16 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.82 10.435C.96 9.522.5 8.5.5 6.842.5 3.926 2.547 1.312 5.525.02l.744 1.148C3.49 2.67 2.947 4.622 2.73 5.852c.448-.232 1.033-.312 1.608-.26 1.503.14 2.688 1.374 2.688 2.908a2.917 2.917 0 0 1-2.917 2.917 3.23 3.23 0 0 1-2.29-.982m8.333 0c-.859-.912-1.32-1.935-1.32-3.592 0-2.917 2.048-5.531 5.025-6.823l.744 1.148c-2.779 1.503-3.322 3.454-3.539 4.684.448-.232 1.034-.312 1.608-.26 1.503.14 2.688 1.374 2.688 2.908a2.917 2.917 0 0 1-2.916 2.917 3.22 3.22 0 0 1-2.29-.982"
  })));
};
export default SvgQuotes;